export const ANSWER_OPTIONS = ['A', 'B', 'C', 'D', 'E'];

// Marks a question with no answer. Only set manually by the user, never by the AI extraction.
export const BLANK_ANSWER = 'blank';

export const Phase = {
  SEARCH: 'search',
  BLOCKED: 'blocked',
  ANSWERING: 'answering',
  SUCCESS: 'success',
};
